import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import * as commonVar from 'libs/commonVar';

import { Grid, Label, Icon, Segment, Progress, Accordion, Image } from 'semantic-ui-react';

import { CtLicenseRequest, CtLicenseDelete } from 'containers';
import * as common from 'libs/commonFunc';

import moment from 'moment';

import classNames from 'classnames/bind';
import styles from './LicenseListRow.css';
import ExamDetail from '../exam/ExamDetail';
const cx = classNames.bind(styles);

class LicenseListRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTargetLimitInto: false,
      isExamLimitInto: false
    };
  }

  // 라이센스 사용 내역 열기
  handleToggleLicenseDetail = () => {
    if (!!this.state.isTargetLimitInto) {
      this.setState({
        isTargetLimitInto: false
      });
    } else {
      this.setState({
        isTargetLimitInto: true
      });
    }

    if (!!this.state.isExamLimitInto) {
      this.setState({
        isExamLimitInto: false
      });
    } else {
      this.setState({
        isExamLimitInto: true
      });
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { licenseInfo, existLicenseType, existLicenseData, status, vertical, maintainLicense } = this.props;
    const { handleToggleLicenseDetail } = this;
    const nowEpoch = common.nowEpoch();
    const targetNoArray = [];
    const {
      licenseNo,
      serviceName,
      startEpoch,
      endEpoch,
      licenseCount,
      licenseType,
      examUsedCount,
      examLimitCount,
      examLimitInfo,
      targetLimitInfo,
      orderUserName,
      orderUserEmail,
      regEpoch,
      issueEpoch,
      targetUsedCount
    } = licenseInfo;

    const licenseStatus = status !== undefined ? status : existLicenseData[existLicenseType]['byNo'][licenseNo];
    const licenseOptionData = {
      0: {
        labelColor: 'yellow',
        labelContent: defineMessages(formatMessage({ id: 'LicenseList_1', defaultMessage: '신청중' })),
        gridClass: 'license-request license-process',
        periodProgressProps: {}
      },
      1: {
        labelColor: 'green',
        labelContent: defineMessages(formatMessage({ id: 'LicenseList_2', defaultMessage: '사용중' })),
        gridClass: 'license-use license-process',
        periodProgressProps: { active: true }
      },
      2: {
        labelColor: 'blue',
        labelContent: defineMessages(formatMessage({ id: 'LicenseList_3', defaultMessage: '사용대기' })),
        gridClass: 'license-ready license-process',
        periodProgressProps: {}
      },
      3: {
        labelColor: 'grey',
        labelContent: defineMessages(formatMessage({ id: 'LicenseList_4', defaultMessage: '만료' })),
        gridClass: 'license-expired license-process',
        periodProgressProps: { color: 'grey' }
      }
    };
    const licenseOption = licenseOptionData[licenseStatus];

    let expireSoon;
    // 기간 라이센스만 표시
    if (existLicenseType === 'period' && licenseStatus !== 0) {
      if (nowEpoch > endEpoch || licenseStatus === 3) {
        expireSoon = (
          <Label className={cx('expire-soon')} basic>
            <Image src="/img/setting/forbidden.png" />
            {defineMessages(formatMessage({ id: 'LicenseList_4', defaultMessage: '만료' }))}
          </Label>
        );
      } else if (endEpoch - nowEpoch < 14 * 24 * 60 * 60) {
        expireSoon = (
          <Label className={cx('expire-soon')} basic>
            <Image src="/img/setting/forbidden.png" />
            {defineMessages(formatMessage({ id: 'LicenseList_5', defaultMessage: '만료까지' })) +
              ' ' +
              moment.duration((endEpoch - nowEpoch) * 1000).humanize() +
              ' ' +
              defineMessages(formatMessage({ id: 'LicenseList_21', defaultMessage: '' }))}
          </Label>
        );
      }
    }
    // 횟수
    if (existLicenseType === 'times') {
      if (licenseStatus === 3) {
        expireSoon = (
          <Label className={cx('expire-soon')} basic>
            <Image src="/img/setting/forbidden.png" />
            {defineMessages(formatMessage({ id: 'LicenseList_4', defaultMessage: '만료' }))}
          </Label>
        );
      }
    }

    let periodPercent = 0;
    // 만료
    if (licenseStatus === 3) {
      periodPercent = 100;
      // 사용중
    } else if (licenseStatus === 1) {
      // 기간 라이센스
      if (licenseType === 1 || licenseType === 2) {
        periodPercent = Math.round((nowEpoch - startEpoch) / (endEpoch - startEpoch) * 100);
        // 횟수 라이센스
      } else if (licenseType === 4) {
        periodPercent = Math.round(examUsedCount / examLimitCount * 100);
      }
    }

    // 횟수 상세보기 - 훈련, 교육
    const detailList = [];
    if (!!this.state.isExamLimitInto && !!examLimitInfo) {
      examLimitInfo.map((infoDetail, index) => {
        const examNoArray = [];
        if (!!infoDetail.examNoArray && infoDetail.examNoArray.length > 0) {
          infoDetail.examNoArray.map((data, index) => {
            examNoArray.push(data);
          });
        }
        detailList.push(
          <div key={index}>
            {!!infoDetail.examNo && (
              <div className={cx('content-list', 'mtb-5')}>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_33', defaultMessage: '훈련명' }))}
                  </span>
                  <span className={cx('detail-content')}>{infoDetail.examName}</span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_34', defaultMessage: '훈련 기간' }))}
                  </span>
                  <span className={cx('detail-content')}>
                    {common.timeFormatFromUTCEpoch(infoDetail.examStartEpoch, 3) +
                      ' ~ ' +
                      common.timeFormatFromUTCEpoch(infoDetail.examEndEpoch, 3)}
                  </span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_35', defaultMessage: '템플릿명' }))}
                  </span>
                  <span className={cx('detail-content')}>
                    {infoDetail.templatePick === 1 ? (
                      <Label basic size="small" className={cx('template-user-label color-temp-user')}>
                        {defineMessages(
                          formatMessage({
                            id: 'ExamTemplateList_3',
                            defaultMessage: '사용자'
                          })
                        )}
                      </Label>
                    ) : (
                        <Label basic size="small" className={cx('template-user-label color-temp-system')}>
                          {defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
                        </Label>
                      )}
                    {infoDetail.templateName}
                  </span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_36', defaultMessage: '훈련 실행자' }))}
                  </span>
                  <span className={cx('detail-content')}>{infoDetail.userName + '(' + infoDetail.userEmail + ')'}</span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_37', defaultMessage: '훈련 대상수' }))}
                  </span>
                  <span className={cx('detail-content')}>
                    {infoDetail.targetNoArray.length}
                    {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                  </span>
                </div>
              </div>
            )}
            {!!infoDetail.eduNo && (
              <div className={cx('content-list', 'mtb-5')}>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_39', defaultMessage: '교육명' }))}
                  </span>
                  <span className={cx('detail-content')}>{infoDetail.eduName}</span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_40', defaultMessage: '교육 기간' }))}
                  </span>
                  <span className={cx('detail-content')}>
                    {common.timeFormatFromUTCEpoch(infoDetail.startEpoch, 3) +
                      ' ~ ' +
                      common.timeFormatFromUTCEpoch(infoDetail.endEpoch, 3)}
                  </span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_41', defaultMessage: '교육 실시자' }))}
                  </span>
                  <span className={cx('detail-content')}>{infoDetail.userName + '(' + infoDetail.userEmail + ')'}</span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_42', defaultMessage: '교육 대상수' }))}
                  </span>
                  <span className={cx('detail-content')}>
                    {infoDetail.targetNoArray.length}
                    {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                  </span>
                </div>
                <div>
                  <span className={cx('detail-title')}>
                    {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_43', defaultMessage: '컨텐츠' })) + 'No'}
                  </span>
                  <span className={cx('detail-content')}>{infoDetail.eduAttachNo}</span>
                </div>
                {!!examNoArray &&
                  examNoArray.length > 0 && (
                    <div>
                      <span className={cx('detail-title')}>
                        {'· ' + defineMessages(formatMessage({ id: 'LicenseEdit_44', defaultMessage: '연결 훈련' }))}
                      </span>
                      <span className={cx('detail-content')}>{examNoArray.join(', ')}</span>
                    </div>
                  )}
              </div>
            )}
          </div>
        );
      });
    }

    return (
      <Grid className={cx('user-license-set')}>
        <Grid.Row className={cx('license-box')}>
          <Grid.Column>
            <Segment.Group className={cx('segment-box')}>
              <div className={cx('license-title', licenseOption.gridClass ? licenseOption.gridClass : '')}>
                <Image src="/img/setting/license-off.png" />
                <div className={cx('title-box')}>
                  <div className={cx(licenseOption.gridClass ? licenseOption.gridClass : '')}>
                    {licenseOption.labelContent}
                  </div>
                  <div className={cx('license-user-title inline-block')}>
                    {!maintainLicense &&
                      serviceName +
                      ' / ' +
                      defineMessages(formatMessage({ id: 'LicenseListRow_1', defaultMessage: '라이센스' })) +
                      ' #' +
                      licenseNo
                    }
                  </div>
                </div>
                {commonVar.isSaas === 1 && (
                  <div className={cx('user-license-menu-set')}>
                    {(licenseStatus === 1 || licenseStatus === 2) && (
                      <CtLicenseRequest actionMode="add" licenseInfo={licenseInfo} />
                    )}
                    {licenseStatus === 3 && <CtLicenseRequest actionMode="renew" licenseInfo={licenseInfo} />}
                    {licenseStatus === 0 && <CtLicenseDelete licenseInfo={licenseInfo} />}
                  </div>
                )}
                {expireSoon}
              </div>
              {!maintainLicense &&
                <div className={cx('license-info')}>
                  {/* 라이센스 타입 */}
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
                    </div>
                    <div className={cx('info-value bold')}>
                      {licenseType === 1 &&
                        defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }))}
                      {licenseType === 2 &&
                        defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))}
                      {licenseType === 4 &&
                        defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
                    </div>
                  </div>
                  {/* 영구 라이센스 */}
                  {licenseType === 1 && (
                    <div className={cx('info-row')}>
                      <div className={cx('info-title')}>
                        {defineMessages(formatMessage({ id: 'LicenseListRow_2', defaultMessage: '유효기간' }))}
                      </div>
                      <div className={cx('info-value')}>
                        {defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }))}
                      </div>
                    </div>
                  )}
                  {/* 기간 라이센스 */}
                  {licenseType === 2 && (
                    <div className={cx('info-row')}>
                      <div className={cx('info-title')}>
                        {defineMessages(formatMessage({ id: 'LicenseListRow_2', defaultMessage: '유효기간' }))}
                      </div>
                      <div className={cx('info-progress-group', vertical ? 'vertical' : '')}>
                        <div className={cx('info-value')}>
                          {common.timeFormatFromUTCEpoch(startEpoch, 3) +
                            ' ~ ' +
                            common.timeFormatFromUTCEpoch(endEpoch, 3)}
                        </div>
                        <div className={cx('info-extra')}>
                          <Progress
                            className={cx('license-progress')}
                            progress
                            //size="small"
                            percent={periodPercent}
                            color={licenseOption.labelColor}
                            {...licenseOption.periodProgressProps}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {/* 횟수 라이센스 - 훈련 횟수 */}
                  {licenseType === 4 && (
                    <div className={cx('info-row')}>
                      <div className={cx('info-title')}>
                        {defineMessages(formatMessage({ id: 'LicenseEdit_30', defaultMessage: '훈련 횟수' }))}
                      </div>
                      <div className={cx('info-progress-group', vertical ? 'vertical' : '')}>
                        <div className={cx('info-value')}>
                          {examUsedCount +
                            ' / ' +
                            examLimitCount +
                            defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))}
                        </div>
                        <div className={cx('info-extra')}>
                          <Progress
                            className={cx('license-progress')}
                            progress
                            //size="small"
                            percent={periodPercent}
                            color={licenseOption.labelColor}
                            {...licenseOption.periodProgressProps}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseListRow_4', defaultMessage: '수량' }))}
                    </div>
                    <div className={cx('info-value')}>
                      {(licenseType === 4
                        ? common.commaNumber(licenseCount)
                        : targetUsedCount + ' / ' + common.commaNumber(licenseCount)) +
                        defineMessages(formatMessage({ id: 'LicenseListRow_8', defaultMessage: '명' }))}
                    </div>
                    <div className={cx('info-extra')}>&nbsp;</div>
                  </div>
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseListRow_5', defaultMessage: '신청자' }))}
                    </div>
                    {orderUserName && orderUserEmail ? (
                      <div className={cx('info-wrap')}>
                        <div className={cx('info-value')}>{orderUserName + ' (' + orderUserEmail + ')'}</div>
                        <div className={cx('info-extra')}>&nbsp;</div>
                      </div>
                    ) : (
                        <div className={cx('info-wrap')}>
                          <div className={cx('info-value')}>
                            {defineMessages(formatMessage({ id: 'LicenseListRow_9', defaultMessage: '관리자' }))}
                          </div>
                          <div className={cx('info-extra')}>&nbsp;</div>
                        </div>
                      )}
                  </div>
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseListRow_6', defaultMessage: '신청일자' }))}
                    </div>
                    <div className={cx('info-value')}>{common.timeFormatFromUTCEpoch(regEpoch)}</div>
                    <div className={cx('info-extra')}>&nbsp;</div>
                  </div>
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseListRow_7', defaultMessage: '발급일자' }))}
                    </div>
                    <div className={cx('info-value')}>{common.timeFormatFromUTCEpoch(issueEpoch)}</div>
                    <div className={cx('info-extra')}>&nbsp;</div>
                  </div>

                  {/* 기간 라이센스 - 라이센스 사용 내역 */}
                  {(licenseType === 1 || licenseType === 2) &&
                    !!targetLimitInfo && (
                      <div className={cx('info-row examLimitInfo-area')}>
                        <div className={cx('info-title')}>
                          {defineMessages(formatMessage({ id: 'LicenseEdit_32', defaultMessage: '사용 내역' }))}
                        </div>
                        <div className={cx('info-value examLimitInfo')}>
                          <Accordion>
                            <Accordion.Title className={cx('info-title-license')} onClick={handleToggleLicenseDetail}>
                              {defineMessages(formatMessage({ id: 'LicenseEdit_38', defaultMessage: '상세 보기' }))}
                            </Accordion.Title>
                            <Accordion.Content active={!!this.state.isTargetLimitInto}>
                              {!!this.state.isTargetLimitInto &&
                                Object.keys(targetLimitInfo).map((infoDetail, index) => {
                                  targetNoArray.push(infoDetail);
                                })}
                              {!!targetNoArray && targetNoArray.length > 0 && <span>{targetNoArray.join(', ')}</span>}
                            </Accordion.Content>
                          </Accordion>
                        </div>
                      </div>
                    )
                    // )
                  }

                  {/* 횟수 라이센스 - 라이센스 사용 내역 */}
                  {licenseType === 4 &&
                    !!examLimitInfo && (
                      <div className={cx('info-row examLimitInfo-area')}>
                        <div className={cx('info-title')}>
                          {defineMessages(formatMessage({ id: 'LicenseEdit_32', defaultMessage: '사용 내역' }))}
                        </div>
                        <div className={cx('info-value examLimitInfo')}>
                          <Accordion>
                            <Accordion.Title className={cx('info-title-license')} onClick={handleToggleLicenseDetail}>
                              {defineMessages(formatMessage({ id: 'LicenseEdit_38', defaultMessage: '상세 보기' }))}
                            </Accordion.Title>
                            <Accordion.Content active={!!this.state.isExamLimitInto}>
                              {!!detailList && detailList}
                            </Accordion.Content>
                          </Accordion>
                        </div>
                      </div>
                    )}
                </div>
              }
              {/* 유지보수 라이센스 */}
              {maintainLicense &&
                <div className={cx('license-info', 'maintain')}>
                  {/* 라이센스 타입 */}
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
                    </div>
                    <div className={cx('info-value bold')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_45', defaultMessage: '유지보수 라이센스' }))}
                    </div>
                  </div>
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_46', defaultMessage: '고객사' }))}
                    </div>
                    <div className={cx('info-value')}>
                      {maintainLicense.licenseHostName}
                    </div>
                  </div>
                  <div className={cx('info-row')}>
                    <div className={cx('info-title')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_47', defaultMessage: '만료일' }))}
                    </div>
                    <div className={cx('info-value')}>
                      {common.timeFormatFromUTCEpoch(maintainLicense.licenseEndDate, 1)}
                    </div>
                  </div>
                </div>}
            </Segment.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid >
    );
  }
}

LicenseListRow.propTypes = {
  //
};
LicenseListRow.defaultProps = {
  //
};

export default injectIntl(LicenseListRow);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseListRow.js